<template>

  <li id="list-item"
    v-on:click="onClick"
    v-bind:class="{ complete: goal.complete }"
    >

    <split-text :type="'words'" :classname="'question-copy'">
      {{getCopy}}
    </split-text>
  </li>
</template>

<script>

import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap'
import WebAudioService from 'src/services/WebAudioService'
import ImageService from 'src/services/ImageService'
import Raf from 'src/helpers/Raf'
import SplitText from 'src/components/_utils/SplitText'

export default {

  name: 'return-copy',
  
  components: {
    SplitText
  },
  
  data() {

    return { }
  },
  
  props: {
    index: Number,
    goal: Object 
  },

  computed: {

    getCopy(){

      let copy;
      
      if(this.index === 0){

        if(this.goal.complete){
          copy = this.goal.title;
        } else {
          copy = 'Try making Ed '+ this.goal.title + ' again?';
        }

      } else {
        copy = this.goal.title;
      }

      return copy;
    }

  },
  
  mounted() {
    if(this.index === 0 && !this.goal.complete){ 
      this.$el.classList.add('target-emotion');
    }
  },
    
  beforeDestroy() {},
  
  methods: {
 
    onClick: function() {
      this.$emit('selected', this.goal)
    }
  },
  
  watch: { }

}

</script>

<style lang="sass" >

  #list-item
    font-size: 1.8rem;
    letter-spacing: 0;
    position: absolute;

    &.complete
      .step
        > div
          background-color: #f8f4e2;
          color: #b0ac98;
          text-decoration: line-through;

    &.target-emotion
    
      .step
        width: 50%;
        margin: 0 auto;

    .step

      > div
        line-height: 1.2;
        margin-bottom: 0.5rem;
        display: inline-block !important;
        background: #f8f4e2;
        color: #b0ac98;
        padding: 0.5rem;

</style> 